import React, { Fragment } from 'react';
import { translate } from '../Services/translation';

const OnClick = (articleNumber) => {
    contactAffiliatePicker.showModal();
    contactAffiliatePicker.dataset.articleNumber = articleNumber;
}

const ContactAffiliateButton = ({
    label,
    articleNumber,
    cssClass,
}) => {
    const hideLabel = cssClass.includes("icon-only");
    return (
        <Fragment>
            <a className={cssClass} onClick={() => OnClick(articleNumber)}>
                {hideLabel ? null : label }
            </a>
            <div className="contact-affiliate-text">
                {translate('code.info.text.contactaffiliate')}
            </div>
        </Fragment>
    );
};
export default ContactAffiliateButton;
